import { ArrowUpRight, ArrowDownRight, type LucideIcon } from 'lucide-react';

interface KpiCardProps {
  icon: LucideIcon;
  label: string;
  value: string;
  /** Week-over-week change (rounded %). Omit/null to show `note` instead. */
  deltaPct?: number | null;
  deltaSuffix?: string;
  /** Shown when there's no delta (e.g. "Precisam de atenção"). */
  note?: string;
}

export function KpiCard({
  icon: Icon,
  label,
  value,
  deltaPct,
  deltaSuffix,
  note,
}: KpiCardProps): JSX.Element {
  const hasDelta = deltaPct !== undefined && deltaPct !== null;
  const up = hasDelta && (deltaPct as number) >= 0;
  const DeltaIcon = up ? ArrowUpRight : ArrowDownRight;

  return (
    <div className="rounded-admin-lg border border-admin-border bg-admin-surface p-5">
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#fededc] text-admin-primary">
        <Icon aria-hidden className="h-[18px] w-[18px]" />
      </div>
      <div className="mt-4 text-sm text-admin-text-soft">{label}</div>
      <div className="mt-1 text-2xl font-bold text-admin-text">{value}</div>
      {hasDelta ? (
        <div
          className={`mt-2 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${
            up ? 'bg-emerald-50 text-admin-success' : 'bg-red-50 text-admin-danger'
          }`}
        >
          <DeltaIcon aria-hidden className="h-3.5 w-3.5" />
          <span>
            {up ? '+' : ''}
            {deltaPct}%{deltaSuffix ? ` ${deltaSuffix}` : ''}
          </span>
        </div>
      ) : note ? (
        <div className="mt-2 inline-flex items-center rounded-full bg-admin-surface-alt px-2 py-0.5 text-xs font-medium text-admin-text-soft">
          {note}
        </div>
      ) : null}
    </div>
  );
}
